import { render } from "./iconMinus.vue?vue&type=template&id=1aa0db63"
import script from "./iconMinus.vue?vue&type=script&lang=js"
export * from "./iconMinus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__